import debug from 'debug';
import { r as getDeviceTimeOffset, w as writeEvaRecord, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import axios from 'axios';
import 'vue';

/**
 * DateTime helper functions
 */
var timeStampSeconds = function timeStampSeconds() {
  if (process.env.VUE_APP_IS_LOAN) {
    return Math.round((Date.now() + getDeviceTimeOffset()) / 1000);
  } else {
    return Math.round(Date.now() / 1000);
  }
};
var millisToSecondsOffset = function millisToSecondsOffset(millies) {
  if (process.env.VUE_APP_IS_LOAN) {
    return Math.round((millies + getDeviceTimeOffset()) / 1000);
  } else {
    return Math.round(millies / 1000);
  }
};

var log = debug('xpedeo-core:eva');
debug.enable(process.env.VUE_APP_DEBUG);
var evaMediaDirective = {
  bind: function bind(el, binding, vnode) {
    var maxProgress = 0;
    var recordedTime = null;
    vnode.componentInstance.$on('media-progress-changed', function (e) {
      log("v-eva-media.media-progress-changed");

      if (maxProgress < vnode.componentInstance.progress) {
        maxProgress = vnode.componentInstance.progress;
      }
    });
    vnode.componentInstance.$on('media-playing', function (e) {
      log("v-eva-media.media-playing");

      if (recordedTime === null) {
        recordedTime = timeStampSeconds();
      }
    });
    vnode.componentInstance.$on('media-pause', function (e) {
      log("v-eva-media.media-pause"); // writeMediaRecord(vnode)
    });
    vnode.componentInstance.$on('media-session-ended', function (e) {
      log("v-eva-media.media-session-ended");
      console.log('session ended');
      var mediaRecord = {
        'start': recordedTime,
        'end': timeStampSeconds(),
        'complete': Math.round(maxProgress * 100),
        'langcode': vnode.componentInstance.locale,
        'pageid': vnode.componentInstance.$route.params.id,
        'binid': vnode.componentInstance.binaryId
      };
      log('mediarec complete', mediaRecord.complete);
      vnode.componentInstance.$xp.eva.addMedia(mediaRecord);
    });
  }
}; // These consts are for (browser, user-app) versions, not used on Loan-Devices.

var minimumPartialPacket = 500; // 00 // in Bytes

var maximumFailTimes = 50; // Number of re-send calls when axios fails

var maximumVisitStartDiff = 8; // in hours

Storage.prototype.setObj = function (key, obj) {
  return this.setItem(key, JSON.stringify(obj));
};

Storage.prototype.getObj = function (key) {
  return JSON.parse(this.getItem(key));
};

var eva = {
  _stats: {
    vstart: null,
    vend: null,
    pages: [],
    media: {},
    geo: [],
    deviceId: null,
    platform: null
  },
  __$xp: null,
  startVisit: function startVisit() {
    log("startVisit()");
    this._stats.vstart = timeStampSeconds();
    log('StartVisit timestamp:', this._stats.vstart);
    this._stats.vend = null;
    this._stats.pages = [];
    this._stats.media = [];
    this._stats.geo = [];
    this._stats.deviceId = this.__$xp.device.deviceId;

    if (this.__$xp.device.isLoan) {
      this._stats.platform = this.__$xp.device.platform + '-loan';
    } else {
      this._stats.platform = this.__$xp.device.platform;
    }

    log('in startVisit', this._stats.deviceId, this._stats.platform);

    if (!this.__$xp.device.isLoan) {
      var oldEvaRecs = window.localStorage.getItem('oldEvaRecs');

      if (oldEvaRecs && oldEvaRecs.length > 0) {
        var oldRecord = oldEvaRecs[oldEvaRecs.length - 1];

        if (oldRecord && oldRecord !== '') {
          var oldJson = JSON.parse(oldRecord);
          log('oldJson', oldJson);
          var startDiffHours = (timeStampSeconds - oldJson.vstart) / 60 / 60;

          if (oldJson.deviceId === this._stats.deviceId && startDiffHours < maximumVisitStartDiff) {
            log('Restoring eva json from localstorage');
            this._stats = oldJson;
            delete oldEvaRecs[oldEvaRecs.length - 1];

            if (oldEvaRecs.length > 0) {
              this.sendOldRecord(oldEvaRecs[0]);
            }
          } else {
            if (oldEvaRecs) {
              oldEvaRecs.push(oldRecord);
            } else {
              oldEvaRecs = [oldRecord];
            }

            window.localStorage.setItem('oldEvaRecs', oldEvaRecs);
            this.sendOldRecord(oldRecord);
          }
        }
      }
    }
  },
  endVisit: function endVisit() {
    throw new Error("calling eva.endVisit() before installing the plugin");
  },
  addPage: function addPage(data) {
    data.start = millisToSecondsOffset(data.start);
    data.end = millisToSecondsOffset(data.end);
    data.on = Math.round(data.on / 1000);
    data.off = Math.round(data.off / 1000);

    this._stats.pages.push(JSON.parse(JSON.stringify(data)));

    if (!this.__$xp.device.isLoan) {
      this.sendPartialRecord();
    }
  },
  addMedia: function addMedia(data) {
    this._stats.media.push(JSON.parse(JSON.stringify(data)));

    if (!this.__$xp.device.isLoan) {
      this.sendPartialRecord();
    }
  },
  addGeoInfo: function addGeoInfo(data) {
    data.start = millisToSecondsOffset(data.start);
    data.duration = Math.round(data.duration / 1000);

    this._stats.geo.push(JSON.parse(JSON.stringify(data)));

    if (!this.__$xp.device.isLoan) {
      this.sendPartialRecord();
    }
  },
  sendPartialRecord: function sendPartialRecord() {
    var evaRecord = JSON.stringify(this._stats);
    var recByteSize = this.lengthInUtf8Bytes(evaRecord);
    log('sendPartialRecord, size :', recByteSize, ' minimum is ', minimumPartialPacket);

    if (this._stats.vend === null && recByteSize < minimumPartialPacket) {
      window.localStorage.setItem('evaRecord', evaRecord);
      return;
    }

    window.localStorage.setItem('evaRecord', '');
    var keys = window.localStorage.getObj('evaRecQueKeys');
    var key = 'toSendEvaRecord' + Date.now();
    window.localStorage.setItem(key, evaRecord);
    keys === null ? keys = [key] : keys.push(key);
    window.localStorage.setObj('evaRecQueKeys', keys);
    this._stats.pages = [];
    this._stats.media = [];
    this._stats.geo = [];
    this.failTimes = 0;
    this.sendPartialRecords();
  },
  sendPartialRecords: function () {
    var _sendPartialRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _tryNumStr, keys, key, evaRecord, timeoutLength, oldRecs;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.failTimes >= 50)) {
                _context.next = 4;
                break;
              }

              log('Something is wrong with the internet connection, upload failed.');
              this.failTimes = 0;
              return _context.abrupt("return");

            case 4:
              _tryNumStr = this.failTimes > 0 ? ' for the ' + this.failTimes + ' time.' : '.';
              log("Trying to send eva recs".concat(_tryNumStr));
              keys = window.localStorage.getObj('evaRecQueKeys');
              log(keys);

              if (!(keys.length > 0)) {
                _context.next = 32;
                break;
              }

              key = keys[0];
              evaRecord = window.localStorage.getItem(key);
              timeoutLength = 5000;
              _context.prev = 12;
              _context.next = 15;
              return axios.post(window.XPEDEO_SETTINGS.content.remoteUrl + 'eva/record/', evaRecord);

            case 15:
              log('Sending partial record:', evaRecord);
              log("sendPartialRecords() sending eva-record with key ".concat(key, " on ").concat(this.platform, " was successful for ").concat(this.deviceId));
              log('SentRecord:', evaRecord);
              keys.shift();
              window.localStorage.setObj('evaRecQueKeys', keys);
              window.localStorage.removeItem(key);
              setTimeout(this.sendPartialRecords, timeoutLength);
              _context.next = 30;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](12);
              log("sendPartialRecords() error", _context.t0);
              log("Retrying to send Record in ".concat(timeoutLength, " ms"));
              this.failTimes++;
              setTimeout(this.sendPartialRecords, timeoutLength);

            case 30:
              _context.next = 35;
              break;

            case 32:
              this.failTimes = 0;
              oldRecs = window.localStorage.getItem('oldEvaRecs');

              if (oldRecs && oldRecs.length > 0) {
                this.sendOldRecord(oldRecs[0]);
              }

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[12, 24]]);
    }));

    function sendPartialRecords() {
      return _sendPartialRecords.apply(this, arguments);
    }

    return sendPartialRecords;
  }(),
  sendOldRecord: function () {
    var _sendOldRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rec) {
      var _this = this;

      var oldRecs, i, _rec;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axios.post(window.XPEDEO_SETTINGS.content.remoteUrl + 'eva/record/', rec);

            case 3:
              log("sendOldRecord() sending eva data on ".concat(this.platform, " was successful for ").concat(rec.deviceId));
              oldRecs = window.localStorage.getItem('oldEvaRecs');
              i = 0;

            case 6:
              if (!(i < oldRecs.length)) {
                _context2.next = 13;
                break;
              }

              if (!(oldRecs[i] === rec)) {
                _context2.next = 10;
                break;
              }

              delete oldRecs[i];
              return _context2.abrupt("break", 13);

            case 10:
              i++;
              _context2.next = 6;
              break;

            case 13:
              window.localStorage.setItem('oldEvaRecs', oldRecs);

              if (oldRecs.length > 0) {
                _rec = oldRecs[0];
                setTimeout(function () {
                  return _this.sendOldRecord(_rec);
                }, 2500);
              }

              _context2.next = 24;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              log("sendOldRecord() error", _context2.t0);
              this.failTimes++;

              if (!(this.failTimes >= maximumFailTimes)) {
                _context2.next = 23;
                break;
              }

              return _context2.abrupt("return");

            case 23:
              setTimeout(function () {
                return _this.sendOldRecord(rec);
              }, 5000);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 17]]);
    }));

    function sendOldRecord(_x) {
      return _sendOldRecord.apply(this, arguments);
    }

    return sendOldRecord;
  }(),
  lengthInUtf8Bytes: function lengthInUtf8Bytes(str) {
    // returns the byte length of a utf8 string
    var s = str.length;

    for (var i = str.length - 1; i >= 0; i--) {
      var code = str.charCodeAt(i);
      if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
      if (code >= 0xDC00 && code <= 0xDFFF) i--; // trail surrogate
    }

    return s;
  },
  install: function install(Vue, opts, $xp, cfg) {
    var _this2 = this;

    if ($xp.evaInstalled) {
      return;
    }

    Vue.directive('eva-media', evaMediaDirective);

    this.endVisit = function () {
      log('endVisit()');
      _this2._stats.vend = timeStampSeconds();

      if ($xp.device.isLoan) {
        log('platform:', _this2._stats.platform);

        try {
          writeEvaRecord(JSON.stringify(_this2._stats));
          log("writeEvaRecord() on load device was successful");
        } catch (error) {
          log("writeEvaRecord() error", error);
        }
      } else {
        _this2._stats.platform = $xp.device.platform;
        log('platform:', $xp.device.platform);

        _this2.sendPartialRecord();
      }
    };

    $xp.evaInstalled = true;
    Vue.util.defineReactive($xp, 'eva', this);
    this.__$xp = $xp;
  }
};

export default eva;
